// extracted by mini-css-extract-plugin
export default {"card":"Result_card__nylmf","box":"Result_box__bgEaP","title":"Result_title__+RJ7m","text":"Result_text__IevG3"};